import styled from 'styled-components';
import { rem } from 'polished';

const StyledWrapper = styled.div`
  margin-bottom: ${rem('30px')};
  max-width: ${rem('559px')};
`;

const StyledImage = styled.img`
  height: auto;
  width: 100%;
  cursor: pointer;
`;

export { StyledWrapper, StyledImage };
